// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Paper, Table, TableBody, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../../../common/iconButtons/DeleteButton'
import EditButton from '../../../../../common/iconButtons/EditButton'
import { alphaSort } from '../../../../../common/utils'
import { i18n } from '../../../../index'
import { deleteIntroductionLink } from '../../queries'
import css from './LinksTable.css'

function LinksTable({ data, onDelete, onEdit, companyId }) {
  return (
    <Paper>
      {data.length ? (
        <Table className={css.table}>
          <TableBody>
            {alphaSort('fileName', data).map((link) => (
              <Row key={link.id} link={link} onDelete={onDelete} onEdit={onEdit} companyId={companyId} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <div className={css.noResults}>{i18n.t('admin.introduction.noResults')}</div>
      )}
    </Paper>
  )
}

function Row({ link, onDelete, onEdit, companyId }) {
  return (
    <TableRow>
      <TableCell>{link.fileName}</TableCell>
      <TableCell className={css.hrefCell}>{link.href}</TableCell>
      <TableCell className={css.tagCell}>{link.linkTags?.map((tag) => tag.name).join(', ') ?? ''}</TableCell>
      <TableCell className={css.actionsCell}>
        <div>
          <EditButton onClick={() => onEdit(link)} />

          <Mutation mutation={deleteIntroductionLink}>
            {(onMutate) => <DeleteButton onClick={() => onDelete(onMutate, link.id, companyId)} />}
          </Mutation>
        </div>
      </TableCell>
    </TableRow>
  )
}

export default LinksTable
